import React from 'react'
import {Trans} from 'react-i18next'

import {Grid, Typography} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

import {ReactComponent as FileIcon} from '@progyny/assets/icons/file.svg'
import {ReactComponent as HeartMessageIcon} from '@progyny/assets/icons/heart-message.svg'
import {ReactComponent as MidwifeIcon} from '@progyny/assets/icons/midwife.svg'
import PostpartumAssessment from '@progyny/pages/Consultations/Postpartum/PostpartumAssessment'
import ConsultationPageLayout from '@progyny/pages/Consultations/components/ConsultationPageLayout'
import ConsultationRoutes from '@progyny/pages/Consultations/components/ConsultationRoutes'
import P3ConsultationViewContent, {
  type P3ActiveTab,
} from '@progyny/pages/Consultations/components/P3ConsultationViewContent'
import ProgramCard from '@progyny/pages/Consultations/components/ProgramCard'
import {POSTPARTUM_HUB_PROGRAM_SLUGS} from '@progyny/pages/Consultations/constants'

const POSTPARTUM_BASE_PATH = '/consultations/postpartum'

const useStyles = makeStyles()((theme) => ({
  cardsHeadline: {
    width: '100%',
    maxWidth: '1256px',
    height: '24px',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#251F1F',
    marginBottom: theme.spacing(1),
  },
}))

const PostpartumProgramsOverview: React.FC<{colors: any}> = ({colors}) => {
  const {classes} = useStyles()

  return (
    <Grid container rowGap={2}>
      <Typography className={classes.cardsHeadline} component='h4'>
        <Trans i18nKey='consultations_postpartum_postpartum_consultation_page_your_program' />
      </Typography>
      <Grid container spacing={3}>
        <ProgramCard
          slug='postpartum-support'
          icon={FileIcon}
          color='dark'
          colors={colors}
          fullWidth
          isFullRow
        />
      </Grid>

      <Typography className={classes.cardsHeadline} component='h4' mt={4}>
        <Trans i18nKey='consultations_postpartum_postpartum_consultation_page_additional_suppo' />
      </Typography>
      <Grid container spacing={3}>
        <ProgramCard
          slug='postpartum-emotional-support-program'
          icon={HeartMessageIcon}
          color='bright'
          colors={colors}
        />
        <ProgramCard
          slug='postpartum-ask-a-midwife'
          isAskAMidwife
          icon={MidwifeIcon}
          color='bright'
          colors={colors}
        />
      </Grid>
    </Grid>
  )
}

const PostpartumViewWrapper: React.FC<{activeTab: P3ActiveTab}> = ({
  activeTab,
}) => (
  <ConsultationPageLayout consultationSlug='postpartum'>
    {(consultation, colors, theme, refetchConsultationDetail) => (
      <P3ConsultationViewContent
        basePath={POSTPARTUM_BASE_PATH}
        consultation={consultation}
        colors={colors}
        theme={theme}
        activeTab={activeTab}
        hub={{
          onboardingConsultationSlug: 'postpartum',
          programSlugs: POSTPARTUM_HUB_PROGRAM_SLUGS,
        }}
        overview={<PostpartumProgramsOverview colors={colors} />}
        onRefetchConsultationDetail={refetchConsultationDetail}
      />
    )}
  </ConsultationPageLayout>
)

const PostpartumOverview: React.FC = () => (
  <PostpartumViewWrapper activeTab='overview' />
)

const PostpartumConsultationPage: React.FC = () => {
  return (
    <ConsultationRoutes
      consultationSlug='postpartum'
      assessmentComponent={PostpartumAssessment}
      overviewComponent={PostpartumOverview}
      onboardingSlugOverride='postpartum-support'
      upcomingPastView={({activeTab}) => (
        <PostpartumViewWrapper activeTab={activeTab} />
      )}
    />
  )
}

export default PostpartumConsultationPage
